import { render, staticRenderFns } from "./settlement_detail_list.vue?vue&type=template&id=6c0cbca1"
import script from "./settlement_detail_list.vue?vue&type=script&lang=js"
export * from "./settlement_detail_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports